import { all } from 'redux-saga/effects';
import loginSaga from './login';
import logoutSaga from './logout';
import getAvailableModulesSaga from './modules';
import userSaga from './user';

export default function* securitySaga() {
  yield all([getAvailableModulesSaga(), loginSaga(), logoutSaga(), userSaga()]);
}
